import React from "react";
import {
    // BrowserRouter,
    Route,
} from "react-router-dom";

import Dashboard from './Pages/Dashboard'
import ViewAllNotifications from './Pages/ViewAllNotifications'
import QAPlanningDashboard from './Pages/QAPlanningDashboard'
import InspectionDashboard from './Pages/InspectionDashboard'
import ResourcePlanner from './Pages/ResourcePlanner'
import InspectionDashboard_lineItem from './Pages/InspectionDashboard(lineItem)'
import QAPlanning from './Pages/QAPlanning'
import InspectionDashboardDocument from './Pages/InspectionDashboard-Document'
// import InspectionDashboardDoc from './Pages/InspectionDashboard-Doc'
import AllocateInspector from './Pages/AllocateInspector'
import InspectorDetailsInspector from './Pages/InspectorDetailsInspector'
// import Test from './Pages/TestDashboard'
import Supplier from './Pages/SupplierDashboard'
// import QARequestInspection from './Pages/QAPlannerRequestInspection'
import SupplierRequestInspection from './Pages/SupplierRequestInspectionNew'
import BlankDocuments from './Pages/BlankDocuments'

import RequestPOAcceptance from './Pages/Advanced-RequestPOAcceptance'
import SubmitPOAcceptance from './Pages/Advanced-SubmitPOAcceptance'
import RequestRetentionPayment from './Pages/Advanced-RequestRetentionPayment'
import AppInit from './Pages/AppInit'
import NewInspections from './Pages/NewInspections'
import SupplierInspection from './Pages/SupplierInspection'
import AdvanceDashboard from './Pages/AdvanceDashboard';
import PoAcceptanceTrail from './Pages/Advanced-PoAcceptanceTrail'
import RequestPayment from './Pages/Advanced-RequestPayment'
import ReceivedPOAcceptance from './Pages/Advanced-ReceivedPOAcceptance'
import SendforPayment from './Pages/Advanced-sendforPayment-SCM'
// import Payment from './Pages/Advanced-Payment-scm'
import UploadPaymentAcknowledgement from './Pages/Advanced-UploadPaymentAcknowledgement(Treasury)'
import UploadDispatchClearence from './Pages/Dispatch-UploadDispatchClearence'
import UploadDispatchPOItem from './Pages/Dispatch-UploadDispatchPOItem'
import DispatchDocumentsDashboard from './Pages/Dispatch-MaterialDocumentsDashboard'
import DispatchHome from './Pages/Dispatch-home'
import DispatchMaterialPO from './Pages/Dispatch-MaterialPO'
import GRNPO from './Pages/Dispatch-GRNPO'
import GRNPOItem from './Pages/Dispatch-GRNPOItem'
import DispatchMaterialPOItem from './Pages/Dispatch-MaterialPOItem'
import DispatchProjectView from './Pages/Dispatch-DispatchProjectView'
import DispatchLogistics from './Pages/Dispatch-LogisticsTeam'
import DashboardTPM from './Pages/Dispatch-DocumentsDashboardTPM.js'
import GRNDocuments from './Pages/Dispatch-GRNDocuments'
import DispatchDashboard from './Pages/Dispatch-Dashboard.js'
import DispatchArrangePOItem from './Pages/Dispatch-ArrangePOItem'
import AdvancedReceivePayments from './Pages/Advanced-ReceivePayments.js'
import GRNUploadedPOItem from './Pages/Dispatch-GRNUploadedListofPOItem'
import Audittrail from './Pages/Audit_trail.js'
import ManufacturingClearence from './Pages/Expediting-ManufacturingClearence.js'


import ExpeditingApprovedPOAcceptance from './Pages/Expediting-(Home)ApprovedPOAcceptance'
import ExpeditingPOAcceptanceTrail from './Pages/Expediting-PoAcceptanceTrail'
import ExpeditorDashboard from './Pages/Expediting-Dashboard'
import ExpeditingApproveDeliverySchedule from './Pages/Expediting-ExpeditorToApproveDS'
import ExpeditingAfterApprovingDeliverySchedule from './Pages/Expediting-(Home)ApprovedDeliverySchedule'
import ExpeditingPOAcceptanceTrailExpeditingDocuments from './Pages/Expediting-POAcceptanceTrail(UploadED)'
import ExpeditingApproveReviseDeliverySchedule from './Pages/Expediting-(Home)ApprovedORrevisedDeliverySchedule'
import ExpeditingReviseDeliverySchedule from './Pages/Expediting-(Home)ReviseDeliverySchedule'
import ExpeditingApproveExpeditingDocument from './Pages/Expediting-(Home)ApprovedExpeditingDocument'
// import Navbar from "./Components/Navbar";
import AuditTrail from "./Pages/AuditTrail";


// import advancepaymentscm from "./Pages/Advance-Payment-SCM"
import ExpiditingDashboard from "./Pages/ExpiditingDashboard";
import ExpiditingDashboardLineItems from "./Pages/Expediting-dashboard-lineItems";
// import Navigation from "./Components/Navigation";
import ForgotPassword from "./Pages/ForgotPassword";
import PoAllocation from "./Pages/PurchaseOrderAllocation";
import dispatchTemplate from "./Pages/DispatchTemplate";
import DispatchClearanceTable from "./Pages/DispatchClearanceTable";
import DispatchClearance from "./Pages/DispatchClearance";
import DispatchIssueDC from "./Pages/DisptachIssueDC";
import DispatchVendorDocumentSubmission from "./Pages/DispatchVendorDocumentSubmission";
import DispatchAddTemplate from "./Pages/DispatchAddTemplate";
import BgListDetails from "./Pages/BGList"
import BGDraftDoc from "./Pages/BGDraftDoc"
import CreateUser from "./Pages/CreateUser";

import Manualdownload from "./Pages/Manualdownload"
import Videodownloads from "./Pages/Videodownloads"
import POAnnexure from "./Pages/POAnnexure"
import ImportLogistics from "./Pages/Import-Logistics"
import GRNDataList from "./Pages/GRNDataList"
import AddCustomer from "./Pages/DispatchAddCustomer";
import ReportExtraction from "./Pages/ReportExtraction";
import HRAdminPurchaseOrders from "./Pages/HRAdminPurchaseOrders.js";
const Routes = (props) => {
    return (

        <>

            {/* <Navbar /> */}
            {/* <Navigation /> */}

            <Route path="/" strict exact component={Dashboard} />
            <Route path="/change-password" strict exact component={ForgotPassword} />
            {/* <Route path="/advancepaymentscm" strict exact component={advancepaymentscm} /> */}
            <Route path="/allNotifications" strict exact component={ViewAllNotifications} />
            <Route path="/auditTrailPage" strict exact component={AuditTrail} />
            <Route path="/QAplanningdashboard" strict exact component={QAPlanningDashboard} />
            <Route path="/Inspectiondashboard" component={InspectionDashboard} />
            <Route path="/resource-planner" component={ResourcePlanner} />
            {/* <Route path="/Payment-scm" component={Payment} /> */}
            <Route path="/InspectionDashboard_lineItem" component={InspectionDashboard_lineItem} />
            <Route path="/QAplanning" component={QAPlanning} />
            <Route path="/InspectiondashboardDocument" component={InspectionDashboardDocument} />
            {/* <Route path="/InspectionDashboardDoc" component={InspectionDashboardDoc} /> */}
            <Route path="/AllocateInspector" component={AllocateInspector} parentModal={props.parentModal} />
            <Route path="/InspectorDetailsInspector" component={InspectorDetailsInspector} />
            {/* <Route path="/Test" strict exact component={Test} /> */}
            <Route path="/Supplier" strict exact component={Supplier} />
            {/* <Route path="/QARequestInspection" strict exact component={QARequestInspection} /> */}
            <Route path="/Supplier/RequestInspection" strict exact component={SupplierRequestInspection} />
            <Route path="/RequestPOAcceptance" strict exact component={RequestPOAcceptance} />
            <Route path="/hr-admin-purchase-orders" strict exact component={RequestPOAcceptance} />
            <Route path="/SubmitPOAcceptance" strict exact component={SubmitPOAcceptance} />
            <Route path="/RequestRetentionPayment" strict exact component={RequestRetentionPayment} />
            <Route path="/AppInit/" component={AppInit} props />
            <Route path="/NewInspections/" component={NewInspections} props />
            <Route path="/SupplierInspection/" component={SupplierInspection} props />
            <Route path="/advance-dashboard" component={AdvanceDashboard} props />
            <Route path="/RequestPayment" strict exact component={RequestPayment} />
            <Route path="/PoAcceptanceTrail/" component={PoAcceptanceTrail} props />
            <Route path="/ReceivedPOAcceptance" strict exact component={ReceivedPOAcceptance} />
            <Route path="/SendforPayment" strict exact component={SendforPayment} />

            <Route path="/DispatchHome" strict exact component={DispatchHome} />
            <Route path='/DashboardTPM' strict exact component={DashboardTPM} />
            <Route path="/DispatchMaterialPO" strict exact component={DispatchMaterialPO} />
            <Route path="/GRNPO" strict exact component={GRNPO} />
            <Route path="/GRNPOItem" strict exact component={GRNPOItem} />
            <Route path="/GRNDocuments" strict exact component={GRNDocuments} />
            <Route path="/DispatchMaterialPOItem" strict exact component={DispatchMaterialPOItem} />
            <Route path="/DispatchLogistics" strict exact component={DispatchLogistics} />
            <Route path="/DispatchDashboard" strict exact component={DispatchDashboard} />
            <Route path="/UploadDispatchClearence" strict exact component={UploadDispatchClearence} />
            <Route path="/UploadDispatchPOItem" strict exact component={UploadDispatchPOItem} />
            <Route path="/DispatchDocumentsDashboard" strict exact component={DispatchDocumentsDashboard} />
            <Route path="/DispatchProjectView" strict exact component={DispatchProjectView} />
            <Route path="/BlankDocuments" strict exact component={BlankDocuments} />
            <Route path="/UploadPaymentAcknowledgement" strict exact component={UploadPaymentAcknowledgement} />
            <Route path="/AdvancedReceivePayments" strict exact component={AdvancedReceivePayments} />
            <Route path="/DispatchArrangePOItem" strict exact component={DispatchArrangePOItem} />
            <Route path="/GRNUploadedPOItem" strict exact component={GRNUploadedPOItem} />

            <Route path="/ExpeditingApprovedPOAcceptance" strict exact component={ExpeditingApprovedPOAcceptance} />
            <Route path="/ExpeditingPOAcceptanceTrail" strict exact component={ExpeditingPOAcceptanceTrail} />
            <Route path="/ExpeditorDashboard" strict exact component={ExpeditorDashboard} />
            <Route path="/ExpeditingApproveDeliverySchedule" strict exact component={ExpeditingApproveDeliverySchedule} />
            <Route path="/ExpeditingAfterApprovingDeliverySchedule" strict exact component={ExpeditingAfterApprovingDeliverySchedule} />
            <Route path="/ExpeditingPOAcceptanceTrailExpeditingDocuments" strict exact component={ExpeditingPOAcceptanceTrailExpeditingDocuments} />
            <Route path="/ExpeditingApproveReviseDeliverySchedule" strict exact component={ExpeditingApproveReviseDeliverySchedule} />
            <Route path="/ExpeditingReviseDeliverySchedule" strict exact component={ExpeditingReviseDeliverySchedule} />
            <Route path="/ExpeditingApproveExpeditingDocument" strict exact component={ExpeditingApproveExpeditingDocument} />
            <Route path="/Audittrail" strict exact component={Audittrail} />
            <Route path="/ExpiditingDashboard" strict exact component={ExpiditingDashboard} />
            <Route path="/ManufacturingClearence" strict exact component={ManufacturingClearence} />
            <Route path="/ExpiditingDashboardLineItems" strict exact component={ExpiditingDashboardLineItems} />
            <Route path="/PoAllocation" strict exact component={PoAllocation} />
            <Route path="/DispatchAddTemplate" strict exact component={DispatchAddTemplate} />
            <Route path="/CreateUser" strict exact component={CreateUser} />
            <Route path="/dispatchTemplate" strict exact component={dispatchTemplate} />
            <Route path="/DispatchClearanceTable" strict exact component={DispatchClearanceTable} />
            <Route path="/DispatchClearance" strict exact component={DispatchClearance} />
            <Route path="/DispatchIssueDC" strict exact component={DispatchIssueDC} />
            <Route path="/DCListing" strict exact component={DispatchVendorDocumentSubmission} />
            <Route path="/BgListDetails" strict exact component={BgListDetails} />
            <Route path="/BgDraftDoc" strict exact component={BGDraftDoc} />
            <Route path="/manuals" strict exact component={Manualdownload} />
            <Route path="/videos" strict exact component={Videodownloads} />
            <Route path="/pOAnnexure" strict exact component={POAnnexure} />
            <Route path="/ImportLogistics" strict exact component={ImportLogistics} />
            <Route path="/GRNDataList" strict exact component={GRNDataList} />
            <Route path="/AddCustomer" strict exact component={AddCustomer}/>
            <Route path="/ReportExtraction" strict exact component={ReportExtraction}/>
        </>

    );
};

export default Routes;